import { render } from "./InnovationsByUserTypeChart.vue?vue&type=template&id=abb9e48c"
import script from "./InnovationsByUserTypeChart.vue?vue&type=script&lang=js"
export * from "./InnovationsByUserTypeChart.vue?vue&type=script&lang=js"
script.render = render

export default script